import axios from 'axios';
import UserModel from '../../models/UserModel';
import apiService from '../apiService';
import { store } from '../../store';
import urlUtils from '../../utils/urlUtils';
import getUserModelFromApiReturn from './getUserModelFromApiReturn';

export default async function loginUserByIdPath() {
  try {
    let _user = UserModel(store.getState().user);

    const _params = urlUtils.getSearchParams();
    if (_params?.userId && _params?.userId !== _user.id) {
      let _ret = await axios({
        url: `${apiService.getUrl().faceRecognition}loginAdmin/getUserById`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          userId: _params?.userId,
        }
      });

      if (!_ret.data.success) {
        throw new Error(_ret.data.message);
      }

      _user = getUserModelFromApiReturn(_ret.data);
    }

    return _user;
  } catch (error) {
    console.log('Error loginUserByIdPath', error);
    throw error;
  }
}
